import React, { useMemo } from 'react';
import trans from 'translate';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createNotification } from '../../../redux/actions/uiActions';

export const _championVerificationUrl = 'https://dcentralab.typeform.com/to/Jp5jmOcy';
const moveToVerifyForm = () => window.open(_championVerificationUrl, '_blank');

function ChampionVerifException(message, onError = () => {}, delay = 3000) {
  this.message = message;
  setTimeout(() => {
    onError();
  }, delay);
}

function CreatePoolButton({
  isChampionVerified,
  championData,
  children,
  createNotification,
  poolsList,
  poolsListLoading,
  isChampion,
}) {
  const hasCreatedPool = poolsList?.map((pool) => pool?.champion_id)?.includes(championData?.champion_id);
  const notVerifiedChamp = !isChampionVerified;

  const unverformedChampInfi = notVerifiedChamp && { text: 'pools.create_hpool_apply', onClick: moveToVerifyForm };
  const buttonExtraInfo = { ...unverformedChampInfi };

  const validations = [
    {
      condition: notVerifiedChamp,
      msg: 'errors.not_verfied_user',
      onError: () => window.open(_championVerificationUrl, '_blank'),
    },
  ];

  const validate = () => {
    const foundError = validations.find((validation) => validation.condition);
    if (foundError) {
      const { msg } = foundError;
      const translatedError = trans(msg, undefined, undefined, false);
      throw new ChampionVerifException(translatedError, foundError.onError);
    }
  };

  const onClick = () => {
    try {
      validate();
    } catch (error) {
      createNotification('error', error.message, 3000);
    }
  };

  const childrenWithProps = useMemo(
    () =>
      React.Children.map(children, (child) =>
        React.cloneElement(child, { disabled: notVerifiedChamp, onClick, ...buttonExtraInfo }),
      ),
    [children],
  );

  // champion can create hpool in case of he hasn't created it at all or it still at draft phase
  const showCreatePoolConditions = [isChampion, !poolsListLoading, !hasCreatedPool].every((condition) => condition);

  return <>{showCreatePoolConditions && <>{childrenWithProps}</>}</>;
}
CreatePoolButton.defaultProps = {
  children: null,
  poolsListLoading: false,
  poolsList: [],
  championData: null,
  isChampion: null,
};

CreatePoolButton.propTypes = {
  isChampionVerified: PropTypes.bool.isRequired,
  isChampion: PropTypes.object,
  championData: PropTypes.object,
  children: PropTypes.node,
  poolsList: PropTypes.array,
  poolsListLoading: PropTypes.bool,
  createNotification: PropTypes.func.isRequired,
};
const mapDispatchToProps = {
  createNotification,
};
const mapStateToProps = ({ champion }) => ({
  isChampionVerified: champion.championData?.is_verified_champion === 'VERIFIED',
  isChampion: champion.championData,
  poolsList: champion.poolsList,
  poolsListLoading: champion.poolsListLoading,
  championData: champion.championData,
  championHasOwnPool: champion.championHasOwnPool,
  createNotification,
});

export default connect(mapStateToProps, mapDispatchToProps)(CreatePoolButton);
